import React from 'react';
import glamorous from 'glamorous';
import PropTypes from 'prop-types';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';

import Caption from '../../typography/Caption';

const Container = glamorous.div({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
}, ({ theme }) => ({
  '& .rc-slider-track': {
    backgroundColor: theme.primary.base,
    height: 12,
  },

  '& .rc-slider-rail, & .rc-slider-step': {
    height: 12,
  },

  '& .rc-slider-handle': {
    borderColor: theme.primary.base,
    height: 28,
    width: 28,
    marginTop: -9,
    marginLeft: -28,
  },

  '& .rc-slider-handle-1': {
    marginLeft: 0,
  },

  '& .rc-slider-handle:hover': {
    borderColor: theme.primary.light,
  },

  '& .rc-slider-handle:active': {
    borderColor: theme.primary.dark,
    boxShadow: `0 0 5px ${theme.primary.light}`,
  },

  '& .rc-slider-handle:focus': {
    borderColor: theme.primary.dark,
    boxShadow: `0 0 0 3px ${theme.primary.light}`,
  },
}));

const Row = glamorous.div({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  marginTop: 16,
});

const createSliderWithTooltip = Slider.createSliderWithTooltip;
const RangeWithTooltip = createSliderWithTooltip(Slider.Range);

class RangeInput extends React.PureComponent {
  static propTypes = {
    onChange: PropTypes.func,
    tipFormatter: PropTypes.func,
    defaultValue: PropTypes.arrayOf(PropTypes.number),
    min: PropTypes.number,
    max: PropTypes.number,
    hasTooltip: PropTypes.bool,
    pushable: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.number,
    ]),
  };

  static defaultProps = {
    onChange: () => {},
    tipFormatter: value => `${value}`,
    defaultValue: [25, 75],
    min: 0,
    max: 100,
    hasTooltip: false,
    pushable: true,
  };

  state = {
    minValue: this.props.defaultValue[0],
    maxValue: this.props.defaultValue[1],
  };

  handleChange = (value) => {
    this.setState({
      minValue: value[0],
      maxValue: value[1],
    });

    this.props.onChange(value);
  };

  renderRange() {
    if (this.props.hasTooltip) {
      return (
        <RangeWithTooltip
          {...this.props}
          onChange={this.handleChange}
        />
      );
    }

    return (
      <Slider.Range
        {...this.props}
        onChange={this.handleChange}
      />
    );
  }

  render() {
    const {
      tipFormatter
    } = this.props;

    return (
      <Container>
        {this.renderRange()}
        <Row>
          <Caption>{tipFormatter(this.state.minValue)}</Caption>
          <Caption>{tipFormatter(this.state.maxValue)}</Caption>
        </Row>
      </Container>
    );
  }
}

export default RangeInput;



// WEBPACK FOOTER //
// ./src/components/ui/RangeInput/RangeInput.js